
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsPosTouchPanelTypeDialog extends Serenity.EntityDialog<PsPosTouchPanelTypeRow, any> {
        protected getFormKey() { return PsPosTouchPanelTypeForm.formKey; }
        protected getIdProperty() { return PsPosTouchPanelTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosTouchPanelTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsPosTouchPanelTypeRow.nameProperty; }
        protected getService() { return PsPosTouchPanelTypeService.baseUrl; }
        protected getDeletePermission() { return PsPosTouchPanelTypeRow.deletePermission; }
        protected getInsertPermission() { return PsPosTouchPanelTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsPosTouchPanelTypeRow.updatePermission; }

        protected form = new PsPosTouchPanelTypeForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

           
            
            var stkcode = this.form.TouchPanelType.value
            if (stkcode == 'RT000') {
                this.deleteButton.toggleClass('disabled', true);
                this.deleteButton.toggleClass('disabled', true);
                

            }

            

        }

    }
}